import React, { useEffect } from 'react';
import EmptyState from "../../../components/EmptyState/EmptyState";
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import InvoicesTable from "../../../components/InvoicesTable/InvoicesTable";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./InvoicesView.module.scss";
import { Spinner } from 'seagull';
export default function InvoicesView(props) {
  const {
    agreement,
    refreshAgreement
  } = props;
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const {
    fetchIntegrations
  } = useStoreActions();
  useEffect(() => {
    if (showQboIntegration) {
      fetchIntegrations();
    }
  }, [showQboIntegration]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MinisiteTabHeader, null), /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    "data-testid": "agreement-invoices-view"
  }, /*#__PURE__*/React.createElement(InvoicesTable, {
    filtersClassname: styles.filters,
    relationshipId: agreement.id,
    renderLoader: () => /*#__PURE__*/React.createElement(Spinner, {
      centeredInBox: true,
      centerBoxHeight: 300
    }),
    renderNoInvoices: () => /*#__PURE__*/React.createElement(EmptyState, {
      testid: "invoices-view-empty-state",
      illustration: "invoices",
      paragraphs: ['Invoices are automatically generated according to the terms of each agreement.', 'No invoices have been generated for this agreement yet.']
    }),
    onRetry: async () => {
      await refreshAgreement({
        silent: true
      });
    }
  })));
}